/**
 * Align the carousel to the first slide after mount.
 * Loop clones can land on the wrong slide; rewind/non-loop still needs index 0.
 */
export function initBannerSwiper(swiper) {
  const alignFirst = () => {
    if (!swiper || swiper.destroyed) return;
    try {
      const atStart = swiper.params?.loop ? swiper.realIndex === 0 : swiper.activeIndex === 0;
      if (atStart) return;
      if (swiper.params?.loop && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(0, 0);
      } else if (typeof swiper.slideTo === 'function') {
        swiper.slideTo(0, 0);
      }
    } catch {
      /* noop */
    }
  };

  alignFirst();
  requestAnimationFrame(alignFirst);
}
